<template>
    <div class="PreLoad">
        <div class="spinner-border text-info m-auto" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</template>

<script>
export default {
  name: 'FaqBox',
  data () {},
  mounted () {}
}
</script>

<style scoped>
.PreLoad{
    display: flex;
    position: fixed;
    height: 100dvh;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    background: white;
    z-index: 10;
}
</style>
